module.exports = __webpack_public_path__ + "img/sld_abt.12f4a7c5.svg";